<template>
  <v-dialog
    v-model="dialog"
    width="600"
  >
    <v-card>
      <v-card-title style="word-break: normal;">
        Agregar pago con transferencia
        <v-spacer></v-spacer>
        <v-btn
          icon
          @click="dialog = false"
        >
          <v-icon>fas fa-times</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
      </v-card-text>
      <v-card-actions class="d-flex justify-end">
        <v-btn
          class="mr-2"
          @click="dialog = false"
        >
          Cancelar
        </v-btn>
        <v-btn
          color="primary"
          @click="confirmar()"
        >
          <v-icon small left>fas fa-check</v-icon>
          Confirmar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { roundNumberTF } from '../../util/utils'
import TextFieldMoney from '../util/TextFieldMoney.vue'

export default {
  data () {
    return {
    }
  },
  props: {
    value: Boolean
  },
  computed: {
    dialog: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  watch: {
  },
  methods: {
  }
}
</script>